import { render } from "./ReportUnified.vue?vue&type=template&id=2ca6e921&scoped=true"
import script from "./ReportUnified.vue?vue&type=script&lang=js"
export * from "./ReportUnified.vue?vue&type=script&lang=js"

import "./ReportUnified.vue?vue&type=style&index=0&id=2ca6e921&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca6e921"]])

export default __exports__